<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-chalkboard-teacher fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title" v-if="enrollment.title">{{enrollment.title}}</div> <!-- legacy? -->
            <div class="tile-title" v-else>{{enrollment.courses.title}}</div>

            <div class="mt-3" v-if="enrollment.lessons">
                <b-progress type="is-primary" size="is-small" :value="(enrollment.lessons_completed/enrollment.lessons)*100" class="enroll-progress"/>
                <div class="is-size-7 has-text-grey">{{enrollment.lessons_completed}} of {{enrollment.lessons}} lessons completed.</div>
            </div>

        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat" v-if="enrollment.completed_at"><i class="fas fa-check has-text-success"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <toolbar class="toolbar">
                    <button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="ID">{{enrollment.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'CourseEnrollmentTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            enrollment: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>

<style lang="scss">

    .enroll-progress {
        margin-bottom: 0.2rem !important;

        .progress {
            height: 0.25rem !important;
        }
    }
</style>
